/** Strips a record's excluded keys; both datasource loaders do it to their own entity. */
export const omitKeys = <T extends Record<string, any>, const K extends readonly (keyof T)[]>(
  obj: T,
  keys: K
): Omit<T, K[number]> => {
  const exclude = new Set<keyof T>(keys as readonly (keyof T)[]);
  return Object.fromEntries(Object.entries(obj).filter(([k]) => !exclude.has(k as keyof T))) as Omit<T, K[number]>;
};
